import { on } from 'delegated-events'
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import ajax from '@common/ajax'

const state = {
  calendar: null,
}

const handleView = (e) => {
  const button = e.target.closest('button')

  document.querySelectorAll('.events-view-controls .is-active').forEach((x) => x.classList.remove('is-active'))

  button.classList.add('is-active')

  const listView = document.querySelector('.events-view-list')
  const calendarView = document.querySelector('.events-view-calendar')

  let selectedView = ''

  if (button.dataset.view === 'list') {
    listView.classList.remove('hidden')
    calendarView.classList.add('hidden')
    selectedView = 'list'
  } else {
    listView.classList.add('hidden')
    calendarView.classList.remove('hidden')
    selectedView = 'calendar'

    setupCalendar()
  }

  const windowUrl = new URL(window.location.href)

  windowUrl.search = windowUrl.search.replace(/view=(list|calendar)/, `view=${selectedView}`)

  window.history.replaceState({}, '', windowUrl)

  document.querySelectorAll('[data-page-filters] input[name="view"]').forEach((x) => (x.value = selectedView))

  const clear = document.querySelector('[data-page-filters-clear]')

  if (clear) {
    const clearUrl = new URL(clear.href)
    clearUrl.search = `?view=${selectedView}`

    clear.href = clearUrl.href
  }
}

const setupCalendar = () => {
  const el = document.getElementById('events-calendar')

  if (!el) {
    return
  }

  if (!el.classList.contains('fc')) {
    const endpoint = el.dataset.endpoint

    state.calendar = new Calendar(el, {
      plugins: [dayGridPlugin],
      initialView: 'dayGridMonth',
      dayMaxEvents: window.matchMedia('(min-width: 1024px)').matches ? 3 : 0,
      headerToolbar: {
        left: '',
        center: 'prev,title,next',
        right: '',
      },
      events: async (info, success) => {
        const query = { start: info.startStr, end: info.endStr }
        const urlParams = new URLSearchParams(window.location.search)
        const searchCategory = urlParams.get('category')
        const searchTerm = urlParams.get('search')

        if (searchCategory) {
          query.category = searchCategory
        }

        if (searchTerm) {
          query.search = searchTerm
        }

        const resp = await ajax.url(endpoint).query(query).get().json()

        success(resp)
      },
    })
  }

  state.calendar.render()
}

on('click', '.events-view-controls button', handleView)
on('pagecontent:replace', 'html', setupCalendar)

setupCalendar()
